module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1054-6027f2d1da161a7cd0ec650897812bd0.png";